const version='1.19.6'; const hash='b28101f'; export {version, hash};
